import { render, staticRenderFns } from "./odoo-purchase-order-state-select.vue?vue&type=template&id=f0a4e5c6&scoped=true&"
import script from "./odoo-purchase-order-state-select.vue?vue&type=script&lang=js&"
export * from "./odoo-purchase-order-state-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a4e5c6",
  null
  
)

export default component.exports